import React, { Component } from 'react';
import Banner from '../../../components/Banner/index';
import Footer from '../../../components/Footer/index';

class NotFoundPage extends Component {
  render() {
    return (
      <div>
        <Banner />
        <div className="error404-content">
          <h1>404</h1>
          <h2>Página no encontrada</h2>
          <p>
            La página que estás buscando ha sido movida, eliminada, renombrado o
            quizás nunca existió.
          </p>
          <a href="/" className="button-md button-theme">
            Ir a la página principal
          </a>
        </div>
        <Footer />
      </div>
    );
  }
}

NotFoundPage.defaultProps = {};

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/containers/General/NotFoundPage/index.js